import addressbook from "./addressbook";

export default {
  en: {
    messages: {
      loading:"Loading...",
      notsignedin:"You aren't signed into an account. Please {0} to access account information.",
      signin:"sign in",
     
    }
  },
  de: {
    messages: {
      loading: "Lädt...",
      notsignedin: "Sie sind nicht an einem Konto angemeldet. Bitte {0}, um auf Kontoinformationen zuzugreifen.",
      signin: "Anmelden",

    }
  },
};
